<div class="body">

    <table mat-table [dataSource]="(providerService.customers$|async)|sortedObjectArray:active:direction:(providerService.customers$|async)?.length" class="table" [matSortActive]="active" [matSortDirection]="direction" matSort (matSortChange)="sortData($event)">

        <ng-container matColumnDef="customernumber">
            <th mat-header-cell mat-sort-header="customernumber" *matHeaderCellDef>Nummer</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.customernumber}}

            </td>
            <td mat-footer-cell *matFooterCellDef [attr.colspan]="columns.length" class="footer">
                {{(providerService.customers$|async)?.length}} Kunden
            </td>
        </ng-container>

        <ng-container matColumnDef="customername">
            <th mat-header-cell mat-sort-header="customername" *matHeaderCellDef>Bezeichnung</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.customername}}

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="customerphone">
            <th mat-header-cell mat-sort-header="customerphone" *matHeaderCellDef>Telefon</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.customerphone}}

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="customermail">
            <th mat-header-cell mat-sort-header="customermail" *matHeaderCellDef>E-Mail Adresse</th>
            <td mat-cell *matCellDef="let element">

                {{element.value.customermail}}

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <ng-container matColumnDef="controls">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element" class="control-cell">

                <button mat-icon-button (click)="showCustomer(element.value)">
                    <mat-icon>search</mat-icon>
                </button>

            </td>
            <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;" class="body-row"></tr>
        <tr mat-footer-row *matFooterRowDef="footerColumns; sticky: true"></tr>

    </table>

</div>
